<div class="drop-zone-overlay" id="dropZoneOverlay" (click)="onUploadOverlayClick($event)">
  <div class="drop-zone">
    <button class="cancel-btn" (click)="onHideUploadModal()" mat-icon-button>
      <mat-icon>close</mat-icon>
    </button>
    <input
      class="file-input"
      #uploadInput
      type="file"
      id="uploadInput"
      accept=".csv"
      (change)="onFileUpload($event)" />
    <div class="drop-zone-content">
      <div class="title text-center">
        @if (fileName) {
          <div class="d-flex align-items-center mb-2">
            <div class="me-3">{{ fileName }}</div>
            <button class="btn-sm" (click)="deleteFile()" mat-icon-button>
              <mat-icon>close</mat-icon>
            </button>
          </div>
          @if (uploadError) {
            <div class="text-error">{{ uploadError }}</div>
          }
        } @else {
          <div>Drop file here to upload</div>
          <div class="mb-2">or</div>
          <div>
            <label for="uploadInput" class="file-input-label">Browse for file</label>
          </div>
        }
      </div>
    </div>
  </div>
</div>
